import React from "react";
import { useTranslation } from "../../i18n/LanguageContext";
const PrivacyPolicyComponent = () => {
   const { t } = useTranslation();
   return (
      <div className="kap-policy d-flex flex-column" style={{ gap: "16px" }}>
         <p className="kap-policy__title">
            {t("privacy-policy-tab-label")}
         </p>
         <div className="d-flex flex-column" style={{ gap: "30px" }}>
            <div className="d-flex flex-column">
               <p className="mb-6">{t("privacy-last-updated-text")}</p>
               <p>
                  {t("privacy-intro-websites-prefix-text")}{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://www.i-aps.com"}
                     className="kap-policy__link"
                  >
                     https://www.i-aps.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://kaptechgroup.com"}
                     className="kap-policy__link"
                  >
                     https://kaptechgroup.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://www.kapsurvey.com"}
                     className="kap-policy__link"
                  >
                     https://www.kapsurvey.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://www.kaporg.com"}
                     className="kap-policy__link"
                  >
                     https://www.kaporg.com
                  </a>
                  ,{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://kapinsights.com"}
                     className="kap-policy__link"
                  >
                     https://kapinsights.com
                  </a>{" "}
                  and{" "}
                  <a
                     rel="noopener noreferrer"
                     target="_blank"
                     href={"https://kapcourse.com"}
                     className="kap-policy__link"
                  >
                     https://kapcourse.com
                  </a>
                  {t("privacy-intro-websites-suffix-text")}
               </p>
               <p>{t("personal-information-definition-text")}</p>
               <p>{t("third-party-sites-disclaimer-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("information-we-collect-title")}
               </h4>
               <p>{t("information-categories-intro-text")}</p>
               <p>{t("voluntarily-provided-info-description-text")}</p>
               <p>{t("automatically-collected-info-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">{t("log-data-title")}</h4>
               <p>{t("log-data-description-text")}</p>
               <p>{t("log-data-errors-description-text")}</p>
               <p>{t("log-data-combination-warning-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">{t("device-data-title")}</h4>
               <p>{t("device-data-intro-text")}</p>
               <ul style={{ paddingLeft: "20px" }}>
                  <li>{t("device-type-label")}</li>
                  <li>{t("operating-system-label")}</li>
                  <li>{t("unique-device-identifiers-label")}</li>
                  <li>{t("geo-location-data-label")}</li>
               </ul>
               <p>{t("device-data-settings-note-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("personal-information-title")}
               </h4>
               <p>{t("personal-information-intro-text")}</p>
               <ul style={{ paddingLeft: "20px" }}>
                  <li>{t("name")}</li>
                  <li>{t("email")}</li>
                  <li>{t("unique-device-identifiers-label")}</li>
                  <li>{t("social-media-profiles-label")}</li>
                  <li>{t("date-of-birth-label")}</li>
                  <li>{t("phone-mobile-number-label")}</li>
                  <li>{t("home-mailing-address-label")}</li>
                  <li>{t("work-related-information-label")}</li>
                  <li>{t("company-name-label")}</li>
                  <li>{t("title-field-label")}</li>
               </ul>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("sensitive-information-title")}
               </h4>
               <p>{t("sensitive-information-definition-text")}</p>
               <p>{t("sensitive-information-types-intro-text")}</p>
               <ul style={{ paddingLeft: "20px" }}>
                  <li>{t("gender-label")}</li>
               </ul>
               <p>{t("sensitive-information-consent-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("user-generated-content-title")}
               </h4>
               <p>{t("privacy-user-generated-content-description-text")}</p>
               <p>{t("user-generated-content-publication-notice-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("transaction-data-title")}
               </h4>
               <p>{t("transaction-data-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("legitimate-reasons-title")}
               </h4>
               <p>{t("legitimate-reasons-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("collection-and-use-title")}
               </h4>
               <p>{t("collection-and-use-intro-text")}</p>
               <ul style={{ paddingLeft: "20px" }}>
                  <li>{t("collect-register-account-text")}</li>
                  <li>{t("collect-purchase-subscription-text")}</li>
                  <li>{t("collect-signup-updates-text")}</li>
                  <li>{t("collect-mobile-browser-text")}</li>
                  <li>{t("collect-contact-us-text")}</li>
                  <li>{t("collect-social-media-mention-text")}</li>
                  <p>{t("collection-purposes-intro-text")}</p>
                  <li>{t("purpose-core-features-text")}</li>
                  <li>{t("purpose-customize-experience-text")}</li>
                  <li>{t("purpose-deliver-products-text")}</li>
                  <li>{t("purpose-contact-communicate-text")}</li>
                  <li>{t("purpose-analytics-research-text")}</li>
                  <li>{t("purpose-advertising-marketing-text")}</li>
                  <li>{t("purpose-enable-access-text")}</li>
                  <li>{t("purpose-record-keeping-text")}</li>
                  <li>{t("purpose-legal-compliance-text")}</li>
                  <li>{t("purpose-attribute-content-text")}</li>
                  <li>{t("purpose-security-fraud-text")}</li>
                  <li>{t("purpose-technical-assessment-text")}</li>
               </ul>
               <p>{t("collection-combine-sources-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("security-of-information-title")}
               </h4>
               <p>{t("security-measures-description-text")}</p>
               <p>{t("security-no-guarantee-text")}</p>
               <p>{t("security-password-responsibility-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("retention-period-title")}
               </h4>
               <p>{t("retention-period-description-text")}</p>
               <p>{t("retention-legal-obligation-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("childrens-privacy-title")}
               </h4>
               <p>{t("childrens-privacy-description-text")}</p>
               <p>{t("disclosure-to-third-parties-title")}</p>
               <p>{t("disclosure-intro-text")}</p>
               <ul style={{ paddingLeft: "20px" }}>
                  <li>{t("disclose-affiliate-text")}</li>
                  <li>{t("disclose-service-providers-text")}</li>
                  <li>{t("disclose-employees-text")}</li>
                  <li>{t("disclose-business-partners-text")}</li>
                  <li>{t("disclose-credit-agencies-text")}</li>
                  <li>{t("disclose-law-enforcement-text")}</li>
                  <li>{t("disclose-agents-subcontractors-text")}</li>
                  <li>{t("disclose-collect-process-text")}</li>
                  <li>{t("disclose-business-transfer-text")}</li>
               </ul>
               <p>{t("third-parties-currently-used-text")}</p>
               <ul style={{ paddingLeft: "20px" }}>
                  <li>Google Analytics</li>
                  <li>Open Web Analytics</li>
                  <li>MailChimp</li>
                  <li>SendGrid</li>
                  <li>Google AdSense</li>
                  <li>Bing Ads</li>
                  <li>LinkedIn</li>
                  <li>WhatsApp</li>
                  <li>Facebook</li>
                  <li>Instagram</li>
                  <li>X</li>
                  <li>Paypal</li>
                  <li>Stripe</li>
                  <li>Square</li>
                  <li>Google Payments</li>
                  <li>Apple Pay</li>
                  <li>Amazon Web Services</li>
                  <li>Google Cloud</li>
                  <li>Microsoft Azure</li>
                  <li>ServerMania</li>
               </ul>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("international-transfers-title")}
               </h4>
               <p>{t("international-transfers-description-text")}</p>
               <p>{t("international-transfers-legal-note-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">{t("your-rights-title")}</h4>
               <p>{t("your-choice-description-text")}</p>
               <p>{t("info-from-third-parties-text")}</p>
               <p>{t("marketing-permission-text")}</p>
               <p>{t("access-rights-text")}</p>
               <p>{t("correction-rights-text")}</p>
               <p>{t("non-discrimination-text")}</p>
               <p>{t("download-personal-info-text")}</p>
               <p>{t("data-breach-notification-text")}</p>
               <p>{t("complaints-rights-text")}</p>
               <p>{t("unsubscribe-rights-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("use-of-cookies-title")}
               </h4>
               <p>{t("use-of-cookies-description-text")}</p>
               <p>{t("refer-to-cookie-policy-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("business-transfers-title")}
               </h4>
               <p>{t("business-transfers-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("limits-of-policy-title")}
               </h4>
               <p>{t("limits-of-policy-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("changes-to-policy-title")}
               </h4>
               <p>{t("changes-to-policy-description-text")}</p>
               <p>{t("changes-significant-notice-text")}</p>
               <p>{t("changes-permission-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("au-privacy-act-title")}
               </h4>
               <h4 className="kap-policy__heading">
                  {t("international-transfers-title")}
               </h4>
               <p>{t("au-privacy-act-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("gdpr-compliance-title")}
               </h4>
               <h4 className="kap-policy__heading">
                  {t("data-controller-processor-title")}
               </h4>
               <p>{t("data-controller-processor-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">{t("legal-bases-title")}</h4>
               <p>{t("legal-bases-description-text")}</p>
               <p>{t("legal-bases-grounds-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("consent-from-you-title")}
               </h4>
               <p>{t("consent-from-you-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("performance-of-contract-title")}
               </h4>
               <p>{t("performance-of-contract-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("legitimate-interests-title")}
               </h4>
               <p>{t("legitimate-interests-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("compliance-with-law-title")}
               </h4>
               <p>{t("compliance-with-law-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("eea-transfers-title")}
               </h4>
               <p>{t("eea-transfers-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">{t("your-rights-title")}</h4>
               <p>{t("restrict-processing-rights-text")}</p>
               <p>{t("objecting-to-processing-text")}</p>
               <p>{t("data-portability-text")}</p>
               <p>{t("deletion-rights-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("us-states-privacy-title")}
               </h4>
               <p>{t("us-states-privacy-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">{t("do-not-track-title")}</h4>
               <p>{t("do-not-track-description-text")}</p>
               <p>{t("do-not-track-standards-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("cookies-and-pixels-title")}
               </h4>

               <p>{t("cookies-and-pixels-description-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("california-privacy-laws-title")}
               </h4>
               <p>{t("california-privacy-financial-incentive-text")}</p>
               <p>{t("california-privacy-request-info-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("california-notice-of-collection-title")}
               </h4>
               <p>{t("california-notice-of-collection-intro-text")}</p>
               <ul style={{ paddingLeft: "20px" }}>
                  <li> {t("ccpa-identifiers-text")}</li>
                  <li>{t("ccpa-customer-records-text")}</li>
                  <li>{t("ccpa-demographics-text")}</li>
                  <li>{t("ccpa-commercial-info-text")}</li>
                  <li>{t("ccpa-internet-activity-text")}</li>
                  <li>{t("ccpa-audio-visual-text")}</li>
                  <li>{t("ccpa-geolocation-text")}</li>
                  <li>{t("ccpa-employment-education-text")}</li>
                  <li> {t("ccpa-inferences-text")}</li>
               </ul>
               <p>{t("california-notice-of-collection-outro-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("right-to-know-delete-title")}
               </h4>

               <p>{t("right-to-know-delete-intro-text")}</p>
               <ul style={{ paddingLeft: "20px" }}>
                  <li>{t("know-delete-categories-collected-text")}</li>
                  <li>{t("know-delete-categories-sources-text")}</li>
                  <li>{t("know-delete-categories-disclosed-text")}</li>
                  <li>{t("know-delete-third-parties-text")}</li>
                  <li> {t("know-delete-business-purpose-text")}</li>
                  <li>{t("know-delete-specific-pieces-text")}</li>
               </ul>
               <p>{t("right-to-know-delete-outro-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">
                  {t("shine-the-light-title")}
               </h4>
               <p>{t("shine-the-light-description-text")}</p>
               <p>{t("shine-the-light-request-text")}</p>
            </div>
            <div>
               <h4 className="kap-policy__heading">{t("contact-us-title")}</h4>
               <p>{t("privacy-contact-us-description-text")}</p>
               <p className="kap-policy__subheading">
                  {t("customer-service-label")}
               </p>
               <a href="mailto:info@kaptechgroup.com" className="kap-policy__link">
                  info@kaptechgroup.com
               </a>
            </div>
         </div>
      </div>
   );
};

export default PrivacyPolicyComponent;
